<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
  <!-- TOP BACKGROUND -->
  <div class="top-bg accent"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- CONTENT HEADER -->
    <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="mr-16" [routerLink]="'/companies'">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1 class="m-0">{{'PERFILES.EMPRESA.TITUHEAD' | translate}}</h1>
    </div>
    <!-- / CONTENT HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card" [ngClass]="">



      <!-- CONTENT -->
      <div class="content p-24">
        <div class="h1">
          {{'CONSULTATABLA.LABEL1' | translate}}
        </div>
        <p class="pt-16 pb-32">
          <!-- {{'CONSULTATABLA.DESCDETAIL' | translate}} -->
        </p>
        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

          <!-- REACTIVE FORM EXAMPLE -->
          <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto">
            <div class="h2 mb-24">{{'CONSULTATABLA.DETAIL' | translate}}</div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>{{'CONSULTATABLA.EMPRESA' | translate}}</mat-label>
                <input matInput value="{{nombreEmpresa}}" disabled>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field appearance="outline" fxFlex="100">
                <mat-label></mat-label>
                <input matInput value="{{idEmpresa}}" disabled style="color:white">
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

              <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                <mat-label>{{'CONSULTATABLA.ADDPRODUCTS' | translate}}</mat-label>
                <mat-select [(ngModel)]='selectSector' [(value)]="tipoProducto" (selectionChange)="checkifCA();">
                  <mat-optgroup *ngFor="let categoria of listaProductos" [label]="instituto != 18 ? translate.instant('CONSULTATABLA.CATEGORIAS.'+categoria.nombre) : translate.instant('CONSULTATABLA.CATEGORIAS.AMCO.'+categoria.nombre)">
                    <mat-option *ngFor="let producto of categoria.productos" [value]="producto.idProducto" [disabled]="!producto.activo" (click)="getEmail_Plantillas(producto.idProducto,producto.activo);">
                      <ng-container [ngSwitch]="instituto">
                        <ng-container *ngSwitchCase="18">
                          <ng-container [ngSwitch]="producto.idProducto">
                            <ng-container *ngSwitchCase="41">
                              <span>ICI</span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                            <span>{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</span>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="19">
                          <ng-container [ngSwitch]="producto.idProducto">
                            <ng-container *ngSwitchCase="41">
                              <span>innovation survey</span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                            <span>{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</span>
                            </ng-container>
                          </ng-container>

                        </ng-container>
                        <ng-container *ngSwitchCase="5">
                        <span>{{'CONSULTATABLA.PRODUCTOSTURQUIA.'+producto.idProducto | translate}}</span>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                        <span>{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</span>
                        </ng-container>
                        </ng-container>
                      <!-- <ng-container *ngIf="producto.idProducto == 41; else restoProds;">
                        <span *ngIf="instituto == 18">ICI</span>
                        <span *ngIf="instituto != 18">{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</span>
                      </ng-container>
                      <ng-container *ngIf="producto.idProducto == 41; ">
                        <span *ngIf="instituto == 19">innovation survey</span>
                        <span *ngIf="instituto != 19">{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</span>
                      </ng-container>
                      <ng-template #restoProds>
                        <span *ngIf="instituto != 5">{{'CONSULTATABLA.PRODUCTOS.'+producto.idProducto | translate}}</span>
                        <span *ngIf="instituto == 5">{{'CONSULTATABLA.PRODUCTOSTURQUIA.'+producto.idProducto | translate}}</span>
                      </ng-template> -->
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>

            </div>




            <ng-container *ngIf="!linkLabel">
              <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4" *ngIf="![8,9,10,17,28,29,30,31,32,33,34,35,36,6,37,38,43,44,45,46,48,49,50,51,53,54,55,59,60,61,62,64,65,66,67,70,71,72,73,74,68,76,77,78,80].includes(tipoProducto)">
                  <mat-label>{{'CONSULTATABLA.SELECT_PLANTILLA' | translate}}</mat-label>
                  <mat-select [(ngModel)]='selectPlantilla' [disabled]="isCA">
                    <ng-container *ngFor="let plantilla of plantillas_lan">
                      <mat-option *ngIf="!plantilla.oculto" [value]="plantilla" class="textoLargo">
                        {{plantilla.nombrePlantilla}}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4" *ngIf="![8,9,10,17,28,29,30,31,32,33,34,35,36,37,38,43,44,45,46,48,49,50,51,53,54,55,59,60,61,62,64,65,66,67,70,71,72,73,74,68,76,77,78,80].includes(tipoProduct)">
                  <mat-label>{{'CONSULTATABLA.SELECT_EMAIL_PLANTILLA' | translate}}</mat-label>
                  <mat-select [(ngModel)]='selectPlantillaEmail' [disabled]="isCA">
                    <mat-option *ngFor="let plantilla_email of plantillas_email" [value]="plantilla_email.paqueteId" class="textoLargo">
                      {{plantilla_email.nombrePaquete}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>

              </div>

              <div fxLayout="row" fxLayoutAlign="start center" >

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4" *ngIf="tipoProducto != 34 && tipoProducto != 35 && tipoProducto != 36 && tipoProducto != 17 && tipoProducto != 53 && tipoProducto != 54 && tipoProducto != 60 && tipoProducto != 70 && tipoProducto != 68">
                  <mat-label *ngIf="anioranking==false || aplicaRanking==2 || aplicaRanking==null">{{'CONSULTATABLA.SELECT_CSSID' | translate}}</mat-label>
                  <mat-label *ngIf="anioranking==true && aplicaRanking==1">{{'CONSULTATABLA.SELECT_CSSIDR' | translate}}</mat-label>
                  <mat-select [(ngModel)]='selectYear'>
                    <mat-option *ngFor="let year of years" [value]="year.anio">
                      {{year.anio}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>
                <!-- <div fxLayout="row" fxLayoutAlign="start center" > -->
                <mat-form-field appearance="outline" style="width:60%" class="pr-4" *ngIf="tipoProducto == 17 || tipoProducto == 53 || tipoProducto == 60 || tipoProducto == 70">
                  <mat-label>{{'CONSULTATABLA.SELECT_CSSID' | translate}} </mat-label>
                  <mat-select [(ngModel)]='selectYear'>
                    <mat-option *ngFor="let results of resultadosAnosAsig" [value]="results.anio">
                      {{results.anio}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="50" class="pr-4" appearance="outline" *ngIf="tipoProducto == 54">
                  <mat-label>{{'CONSULTATABLA.ASOCIARCERTIFICAR.INPUT_2' | translate}}</mat-label>
                  <mat-select [(ngModel)]='selectCertificarActionGo'>
                    <ng-container *ngFor="let certificar of productosContratadosInter.productosCertificar">
                      <mat-option *ngIf="idsProductosGralActionGo.includes(certificar.idProducto)" [value]="certificar">

                        <ng-container [ngSwitch]="certificar.idProducto">
                          <ng-container *ngSwitchCase="41">
                            {{'CONSULTATABLA.ASOCIARCERTIFICAR.MEDIR' | translate}} {{certificar.fechaCertificar}}
                          </ng-container >
                          <ng-container *ngSwitchDefault>
                          {{'CONSULTATABLA.ASOCIARCERTIFICAR.CERTIFICAR' | translate}} {{certificar.fechaCertificar}}
                          </ng-container >
                          </ng-container>
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
                <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto"> -->
                <ng-container *ngIf="validarNivelUser==3">
                  <mat-form-field appearance="outline" style="width:60%" class="pr-4" *ngIf="tipoProducto == 17" >
                    <mat-label>{{'CONSULTATABLA.SURVEYTK_TITU' | translate}}</mat-label>
                    <input matInput [(ngModel)]='surveyToken' placeholder="{{'CONSULTATABLA.SURVEYTK_DESC' | translate}}">
                    <mat-error></mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" style="width:60%" class="pr-4" *ngIf="tipoProducto == 17 || tipoProducto == 60 ">
                    <mat-label>{{'CONSULTATABLA.TABLEAUVER_TITU' | translate}}</mat-label>
                    <input matInput [(ngModel)]='tableauVersion' placeholder="{{'CONSULTATABLA.TABLEAUVER_DESC' | translate}}">
                    <mat-error></mat-error>
                  </mat-form-field>

                </ng-container>


                <!-- </div> -->
                <!-- </div> -->
                <mat-form-field appearance="outline" fxFlex="50" class="pr-4" *ngIf="![8,9,10,17,28,29,30,31,32,33,34,35,36,37,38,43,44,45,46,48,49,50,51,53,54,55,59,60,61,62,64,65,66,67,70,71,72,73,74,8,76,77,78,80].includes(tipoProduct)">
                  <mat-label>{{'CONSULTATABLA.SELECT_CSSID2' | translate}}</mat-label>
                  <mat-select [(ngModel)]='selectEstilo' [disabled]="isCA">
                    <mat-option *ngFor="let estilo of estilos" [value]="estilo.cssId" class="textoLargo">
                      <!--{{estilo.color}}-->
                      {{'CONSULTATABLA.'+estilo.cssId | translate}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4" *ngIf="tipoProducto == 34 ">
                  <mat-label>{{'CONSULTATABLA.SELECT_RESULTS' | translate}}</mat-label>
                  <mat-select [(ngModel)]='selectEstilo_Results'>
                    <mat-option *ngFor="let results of productosContratadosInter.productosCertificar" [value]="results.fechaCertificar">
                      <!--{{estilo.color}}-->
                      {{results.nombreProducto}} {{results.fechaCertificar}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4" *ngIf="tipoProducto == 35 ">
                  <mat-label>{{'CONSULTATABLA.SELECT_RESULTS' | translate}}</mat-label>
                  <mat-select [(ngModel)]='selectEstilo_Results'>
                    <mat-option *ngFor="let results of productosContratadosInter.productosMedir" [value]="results.fechaMedir">
                      <!--{{estilo.color}}-->
                      <!--{{results.nombreProducto}} {{results.fechaMedir}}-->
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>



              </div>

              <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="tipoProducto == 40 || tipoProducto == 75">
                <mat-form-field appearance="outline" fxFlex="50">
                  <mat-label>{{'CONSULTATABLA.SELECT_CSSIDR' | translate}}</mat-label>
                  <mat-select [(ngModel)]='anioRankingCert3'>
                    <mat-option *ngFor="let year of years" [value]="year.anio">
                      {{year.anio}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="50">
                  <mat-label>{{'CONSULTATABLA.TIPORANKING' | translate}}</mat-label>
                  <mat-select [(ngModel)]='tipoRankingCert3'>
                    <mat-option *ngFor="let tipoRank of ['Nacional','Multinacional']" [value]="tipoRank">
                      {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.RANKING.' + tipoRank | translate}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="tipoProducto == 40 || tipoProducto == 75">
                <mat-form-field appearance="outline" fxFlex="50">
                  <mat-label>{{'PERFILES.EMPRESA.SECCIONES.SEC1.RANKING' | translate}}</mat-label>
                  <mat-select #selectRanking [(ngModel)]='rankEnabledCert3' (selectionChange)="filterRanking($event);">
                    <mat-option *ngFor="let rank of rankings" [value]="rank.idSelect">
                      {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.RANKING.'+rank.idSelect+'.NOMBRE' | translate}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="50">
                  <mat-label>{{'PERFILES.EMPRESA.SECCIONES.SEC1.TIPO' | translate}}</mat-label>
                  <mat-select [(ngModel)]='rangoRankingCert3'>
                    <mat-option *ngFor="let tipoRank of rankingItem" [value]="tipoRank.SizeID">
                      {{tipoRank.SizeText}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="idsProductos3_0.includes(tipoProducto) && instituto != 2">
                <mat-form-field appearance="outline" fxFlex="100">
                  <mat-label>{{'CONSULTATABLA.IDOPORTUNITY' | translate}}</mat-label>
                  <input matInput [(ngModel)]='oportunityId' >
                  <mat-error></mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="100">
                  <mat-label>{{'CONSULTATABLA.NAMEOPORTUNITY' | translate}}</mat-label>
                  <input matInput [(ngModel)]='oportunityName' >
                  <mat-error></mat-error>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="idsIntitutos.includes(instituto) && tipoProducto != 70  && tipoProducto != 68">
                <mat-form-field appearance="outline" fxFlex="100">
                  <mat-label>{{'CONSULTATABLA.IDTYPERESULT' | translate}}</mat-label>
                  <mat-select [(ngModel)]='typeOfResultsId'>
                    <mat-option *ngFor="let tipoResults of typeOfResults" [value]="tipoResults.TypeOfresultsID">
                      {{'CONSULTATABLA.CAT_RES.'+tipoResults.TypeOfresultsID | translate}}
                    </mat-option>
                  </mat-select>
                  <mat-error></mat-error>
                </mat-form-field>
            </div>

              <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="idsProductos3_0.includes(tipoProducto)">
                <!-- <mat-form-field appearance="outline" fxFlex="49">
                <mat-label>{{'CONSULTATABLA.PROYECTMANAGER' | translate}}</mat-label>
                <input matInput [(ngModel)]='proyectManager' >
                <mat-error></mat-error>
              </mat-form-field> -->
              <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                <mat-label>{{'CONSULTATABLA.PROYECTMANAGER' | translate}}</mat-label>
                <mat-select [(ngModel)]='proyectManager' >
                  <mat-option *ngFor="let results of projectManager" [value]="results._id" (click)="obtieneCorreoJefe(results)">
                    {{results.fullName}}
                  </mat-option>
                </mat-select>
                <mat-error></mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" fxFlex="49">
                <mat-label>{{'CONSULTATABLA.PROYECTMANAGER_MAIL' | translate}}</mat-label>
                <input matInput [(ngModel)]='proyectManagerEmail'  disabled>
                <mat-error></mat-error>
              </mat-form-field>
            </div>

            <p *ngIf="mostrarMenuCertificar && ([8,9,10,28,29,30,31,32,33,37,38,44,45,46,48,49,50,51,55,61,62,64,65,66,67,71,72,73,74,76,77,78,80].includes(tipoProducto))">
              <!--Solo productos culture audit-->
              <mat-checkbox [formControl]="disableSelect">{{'CONSULTATABLA.ASOCIARCERTIFICAR.CHECK' | translate}}</mat-checkbox>
            </p>
            <!-- SELECCION CERTIFICAR A ASOCIAR EN CA -->
            <mat-form-field fxFlex="50" class="pr-4" appearance="outline" *ngIf="disableSelect.value == true && ([8,9,10,28,29,30,31,32,33,37,38,44,45,46,48,49,50,51,55,61,62,64,65,66,67,71,72,73,74,76,77,78].includes(tipoProducto))">
              <mat-label>{{'CONSULTATABLA.ASOCIARCERTIFICAR.INPUT' | translate}}</mat-label>
              <mat-select [(ngModel)]='selectCertificarAsociado'>
                <ng-container *ngFor="let certificar of productosContratadosInter.productosCertificar">
                  <mat-option *ngIf="idsProductosCertificar.includes(certificar.idProducto)" [value]="certificar.idCertificar">
                    {{'CONSULTATABLA.PRODUCTOS.'+certificar.idProducto | translate}} {{certificar.fechaCertificar}}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>

            <ng-container>
              <p *ngIf="mostrarMenuCertificar && tipoProducto == 53">
                *Asociar lider GO a un certificar
                <!-- <mat-checkbox [formControl]="disableSelect">Asociar lider GO a un certificar </mat-checkbox> -->
              </p>
              <!-- <p *ngIf="mostrarMenuCertificar && tipoProducto == 54">
              *Asociar Action GO a un certificar
            </p> -->
            <!-- SELECCION CERTIFICAR A ASOCIAR EN CA -->
            <mat-form-field fxFlex="50" class="pr-4" appearance="outline" *ngIf="tipoProducto == 53">
              <!-- <mat-form-field fxFlex="50" class="pr-4" appearance="outline" *ngIf="disableSelect.value == true && tipoProducto == 53"> -->
              <mat-label>{{'CONSULTATABLA.ASOCIARCERTIFICAR.INPUT' | translate}}</mat-label>
              <mat-select [(ngModel)]='selectCertificarAsociado'>
                <ng-container *ngFor="let certificar of productosContratadosInter.productosCertificar">
                  <mat-option *ngIf="idsProductosCertificar.includes(certificar.idProducto)" [value]="certificar.idCertificar">
                    {{'CONSULTATABLA.PRODUCTOS.'+certificar.idProducto | translate}} {{certificar.fechaCertificar}}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </ng-container>


        <ng-container *ngIf="linkLabel">
          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
              <mat-error>{{'ALERTS.FIELD' | translate}}</mat-error>
              <mat-label>{{'CONSULTATABLA.URL' | translate}}</mat-label>
              <input matInput id="url" type="url" required>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
              <mat-label *ngIf="anioranking==false || aplicaRanking==2">{{'CONSULTATABLA.SELECT_CSSID' | translate}}</mat-label>
              <mat-label *ngIf="anioranking==true && aplicaRanking==1">{{'CONSULTATABLA.SELECT_CSSIDR' | translate}}</mat-label>
              <mat-select [(ngModel)]='selectYear'>
                <mat-option *ngFor="let year of years" [value]="year.anio">
                  {{year.anio}}
                </mat-option>
              </mat-select>
              <mat-error></mat-error>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="tipoProducto == 68">
          <div fxLayout="row" fxLayoutAlign="start center" >
            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
            <mat-label >{{'CONSULTATABLA.NAM_USE_SWIFT' | translate}}</mat-label>
              <!-- <mat-label >{{'CONSULTATABLA.SELECT_CSSID' | translate}}</mat-label> -->
              <input matInput [(ngModel)]='nameUser' >
              <mat-error></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
            <mat-label >{{'CONSULTATABLA.TO_USE_SWIFT' | translate}}</mat-label>
              <!-- <mat-label >{{'CONSULTATABLA.SELECT_CSSID' | translate}}</mat-label> -->
              <input matInput [(ngModel)]='totalColab' >
              <mat-error></mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutAlign="start center" >
            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
            <mat-label >{{'CONSULTATABLA.EMA_USE_SWIFT' | translate}}</mat-label>
              <!-- <mat-label >{{'CONSULTATABLA.SELECT_CSSID' | translate}}</mat-label> -->
              <input matInput [(ngModel)]='emailUser' (keyup)="validacionCaracEmail($event)">
              <mat-error></mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
            <mat-label >{{'CONSULTATABLA.PASS_USE_SWIFT' | translate}}</mat-label>
              <!-- <mat-label >{{'CONSULTATABLA.SELECT_CSSID' | translate}}</mat-label> -->
              <input matInput [(ngModel)]='passUser' (keyup)="validarPassRegis($event)">
              <mat-error></mat-error>
            </mat-form-field>
            <div class="modalReglas" fxFlex="20">
          <div *ngFor="let reglas of regalasPassRegis" fxLayout="row" fxLayoutAlign="start center" style="margin-top:0px;">
            {{'PERFILES.USUARIO.'+reglas.regla | translate}}
            <mat-icon *ngIf="!reglas.estatus" class="iconletrasReglasFalse">highlight_off</mat-icon>
            <mat-icon *ngIf="reglas.estatus" class="iconletrasReglasTrue">check_circle_outline</mat-icon>
          </div>
          </div>
          </div>
        </ng-container>



        <br>
        <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="end center">
          <button mat-raised-button color="accent" style="width: 20%;" [disabled]="temporal" (click)="registerProduct();">{{'CONSULTATABLA.ADD' | translate}}</button>
        </div>

      </div>
      <br><br><br>
      <!-- / REACTIVE FORM EXAMPLE -->

      <div class="mat-card form-errors-model p-24 mat-elevation-z4">
        <div class="h2 mb-24">{{'CONSULTATABLA.LABELCONTRATADOS' | translate}}</div>
        <pre><code></code></pre>
        <mat-accordion>
          <ng-container *ngIf="productosContratadosInter">
            <mat-expansion-panel *ngIf="productosContratadosInter.productosCertificar.length > 0 && mostrarMenuCertificar " class="mb-20">
              <mat-expansion-panel-header class="accent-100">
                <mat-panel-title>
                  <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.1' | translate}}:</b>
                </mat-panel-title>
                <mat-panel-description>
                  {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-accordion>
                <ng-container *ngFor="let categoria of listaProdsCertificar;index as i; let indexProdGene=index ">

                  <mat-expansion-panel *ngIf="categoria.lista.length > 0" class="m-20">
                    <mat-expansion-panel-header class="accent-100">
                      <mat-panel-title>
                        <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}}:</b> {{categoria.lista.length}} {{'GESTORSTATUS.TITULO' | translate}}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <mat-expansion-panel *ngFor="let producto of categoria.lista; let indexProducto=index " class="m-20" >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="" fxLayout="column" fxLayoutAlign="center start">
                            <b class="mr-20 listCerTitulo">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}} {{producto.fechaCertificar}}</b>
                            <b class="mr-20 listCerTitulo" *ngIf="producto.tokenConfig" >| SurveyToken: {{producto.tokenConfig}}</b>
                          </div>
                        </mat-panel-title>
                        <mat-panel-description>
                          <div class="" fxLayout="row" fxLayoutAlign="space-between center">

                            <b>{{'CONSULTATABLA.INFOR' | translate}}</b>
                            <div *ngIf="producto.correoPendiente" class="icoNuevoMail" matTooltip="{{'CONSULTATABLA.CORREOMODIF' | translate }}">
                              <mat-icon class="s-20">priority_high</mat-icon>
                            </div>
                          </div>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <ng-container [ngSwitch]="producto.idProducto">
                        <ng-container *ngSwitchCase="40">
                          <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em> {{producto.surveyProductId.name}}</em> </p>
                        </ng-container >
                        <ng-container *ngSwitchCase="75">
                          <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em> {{producto.surveyProductId.name}}</em> </p>
                        </ng-container >
                        <ng-container *ngSwitchCase="69">
                        <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em> {{producto.surveyProductId.name}}</em> </p>
                        </ng-container >
                        <ng-container *ngSwitchDefault>
                        <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em>{{'CONSULTARENCUESTA.CATALOGOSPRODUCTOS.'+producto.idPlantilla+'.NOMBRE' | translate}}</em> </p>
                        </ng-container >
                        </ng-container>
                      <!-- <ng-container *ngIf="producto.idProducto != 40">

                      </ng-container>
                      <ng-container *ngIf="producto.idProducto == 40">
                        <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em> {{producto.surveyProductId.name}}</em> </p>
                      </ng-container> -->
                      <div fxLayout="row" fxLayoutAlign="start center">
                        <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idCertificar,producto.nombreProducto,categoria.id,producto.tokenConfig,producto.createdAt)">
                          <mat-icon>settings</mat-icon>
                        </button>
                        <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.RTINFO' | translate}}" color="primary" (click)="verDetallesRT(producto.idCertificar)">
                          <mat-icon>playlist_add_check</mat-icon>
                        </button>
                        <button mat-fab class="mr-20 mb-20" matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaCertificar,producto.idCertificar,producto.idPlantilla,1,producto.idProducto);">
                          <mat-icon>arrow_downward</mat-icon>
                        </button>
                        <ng-container *ngIf="producto.tokenConfig">
                          <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONFING_RESUL.MAT_TOOL_BTN_CONFI_RESULT' | translate}}" color="primary" (click)="verConfigResult(producto.idCertificar,producto.tokenConfig,producto);">
                            <mat-icon>view_quilt</mat-icon>
                          </button>
                        </ng-container>
                        <button mat-fab class="mr-20 mb-20"  matTooltip="{{'CONSULTATABLA.INF_BTN' | translate}}" color="primary" (click)="verInfoProduc(producto)" *ngIf="producto.idProducto == 40">
                          <mat-icon>info</mat-icon>
                        </button>
                        <button mat-fab class="mr-20 mb-20"  matTooltip="{{'CONSULTATABLA.DELE_PRODU' | translate}}" color="primary" (click)="eliminarProduct(producto.idCertificar,'v3')" *ngIf="producto.idProducto == 40 && btnDeletProduct">
                          <mat-icon>delete</mat-icon>
                        </button>

                      </div>

                      <div fxLayout="row" fxLayoutAlign="center" *ngIf="producto.idProducto != 69">

                        <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event,producto.secciones,producto.fechaCertificar,producto.idCertificar)" >
                          <ng-container *ngFor="let seccion of producto.secciones;let indexSecc =index ">
                            <div class="example-box" *ngIf="seccion.visible == 1" cdkDrag style="padding-top: 5px;">
                              <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                              <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                              <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                                <mat-checkbox [(ngModel)]="seccion.estatus" (change)="updateStatus($event,seccion._id,producto.fechaCertificar,producto.idCertificar,producto.tokenConfig,seccion.nombre,producto.survey,producto.idProducto,indexProdGene,indexProducto,indexSecc)">
                                  {{'CONSULTATABLA.'+seccion.nombre | translate}}
                                </mat-checkbox>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-expansion-panel>
                </ng-container>
              </mat-accordion>
            </mat-expansion-panel>



            <mat-expansion-panel *ngIf="productosContratadosInter.productosMedir.length > 0 || productosContratadosInter.productosMedir2.length > 0 || idsProductosCert3Falsos[0].activo" class="mb-20">
              <mat-expansion-panel-header class="accent-100">
                <mat-panel-title>
                  <ng-container [ngSwitch]="instituto">
                    <ng-container *ngSwitchCase="18">
                      <span><b class="mr-20">ICI:</b></span>
                    </ng-container >
                    <ng-container *ngSwitchCase="19">
                      <span><b class="mr-20">Innovation survey</b></span>
                    </ng-container >
                    <ng-container *ngSwitchDefault>
                      <span><b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.2' | translate}}:</b></span>
                    </ng-container >
                    </ng-container>
                </mat-panel-title>
                <mat-panel-description>
                  {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-accordion>
                <ng-container *ngFor="let categoria of listaProdsMedir; index as i; let indexProdGene= index">
                  <mat-expansion-panel *ngIf="categoria.lista.length > 0" class="m-20">
                    <mat-expansion-panel-header class="accent-100">
                      <mat-panel-title>
                        <ng-container [ngSwitch]="instituto">
                          <ng-container *ngSwitchCase="18">
                            <span><b class="mr-20">ICI:</b> {{categoria.lista.length}} {{'GESTORSTATUS.TITULO' | translate}}</span>
                          </ng-container >
                          <ng-container *ngSwitchCase="19">
                            <span><b class="mr-20">Innovation survey</b>{{categoria.lista.length}} {{'GESTORSTATUS.TITULO' | translate}}</span>
                          </ng-container >
                          <ng-container *ngSwitchDefault>
                            <span><b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}}:</b> {{categoria.lista.length}} {{'GESTORSTATUS.TITULO' | translate}}</span>
                          </ng-container >
                          </ng-container>
                      </mat-panel-title>
                      <mat-panel-description>
                        {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <mat-list *ngIf="categoria.id == 2; else nuevosMedir">
                      <mat-list-item *ngFor="let producto of categoria.lista; last as last">
                        <mat-icon matListIcon>arrow_right</mat-icon>
                        <mat-list-item>
                          {{'CONSULTATABLA.PRODUCTOS.2' | translate}} {{producto.fechaMedir}}<br> {{'CONSULTARENCUESTA.PLANTILLA' | translate }}: {{'CONSULTARENCUESTA.CATALOGOSPRODUCTOS.'+producto.idPlantilla+'.NOMBRE' | translate}}
                        </mat-list-item>
                        <div fxLayout="column" fxLayoutAlign="space-between stretch">
                          <button mat-fab matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaMedir,producto.idMedir,producto.idPlantilla,2);" class="m-5">
                            <mat-icon>arrow_downward</mat-icon>
                          </button>
                          <button mat-fab matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idMedir,'Medir',categoria.id)" class="m-5">
                            <mat-icon>settings</mat-icon>
                          </button>
                          <button *ngIf="validarNivelUser==3" mat-fab matTooltip="{{'CONSULTATABLA.LOG_SENDGRIND.TITULO' | translate}}" color="primary" (click)="logSendgrind(producto.idMedir, producto.fechaMedir, producto.idPlantilla, 'medir')">
                            <mat-icon>build</mat-icon>
                          </button>
                          <ng-container *ngIf="producto.tokenConfig">
                            <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONFING_RESUL.MAT_TOOL_BTN_CONFI_RESULT' | translate}}" color="primary" (click)="verConfigResult(producto.idMedir,producto.tokenConfig,producto);">
                              <mat-icon>view_quilt</mat-icon>
                            </button>
                          </ng-container>

                        </div>
                        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                      </mat-list-item>
                    </mat-list>

                    <ng-template #nuevosMedir>
                      <mat-expansion-panel *ngFor="let producto of categoria.lista;let indexProducto= index" class="m-20">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <b *ngIf="categoria.id != 41" class="mr-20">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}}  {{producto.fechaProducto}}</b>
                            <b *ngIf="categoria.id == 41" class="mr-20">
                              <ng-container [ngSwitch]="instituto">
                                <ng-container *ngSwitchCase="18">
                                  ICI {{producto.fechaCertificar}}
                                </ng-container >
                                <ng-container *ngSwitchCase="19">
                                  Innovation survey {{producto.fechaCertificar}}
                                </ng-container >
                                <ng-container *ngSwitchDefault>
                                {{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}} {{producto.fechaCertificar}}
                                </ng-container >
                                </ng-container>
                            </b>
                            <!-- <b *ngIf="categoria.id == 41" class="mr-20">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}} </b> -->
                          </mat-panel-title>
                          <mat-panel-description>
                            {{'CONSULTATABLA.CONFIGURE' | translate}}
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-container *ngIf="producto.idProducto != 41">
                          <p><b >{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em>{{'CONSULTARENCUESTA.CATALOGOSPRODUCTOS.'+producto.idPlantilla+'.NOMBRE' | translate}}</em> </p>
                        </ng-container>
                        <ng-container *ngIf="producto.idProducto == 41">
                          <p><b >{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em> {{producto.surveyProductId.name}}</em> </p>
                        </ng-container>

                        <div fxLayout="row" fxLayoutAlign="start center">
                          <ng-container *ngIf="producto.idProducto != 41">
                            <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idProducto,'MedirGenerio',categoria.id)">
                              <mat-icon>settings</mat-icon>
                            </button>
                            <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.RTINFO' | translate}}" color="primary" (click)="verDetallesRT(producto.idProducto)">
                              <mat-icon>playlist_add_check</mat-icon>
                            </button>
                            <button mat-fab class="mr-20 mb-20" matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaProducto,producto.idProducto,producto.idPlantilla,2);">
                              <mat-icon>arrow_downward</mat-icon>
                            </button>
                            <ng-container *ngIf="producto.tokenConfig">
                              <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONFING_RESUL.MAT_TOOL_BTN_CONFI_RESULT' | translate}}" color="primary" (click)="verConfigResult(producto.idProducto,producto.tokenConfig,producto);">
                                <mat-icon>view_quilt</mat-icon>
                              </button>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="producto.idProducto == 41">
                            <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idCertificar,'MedirGenerio',categoria.id,producto.tokenConfig,producto.createdAt)">
                              <mat-icon>settings</mat-icon>
                            </button>
                            <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.RTINFO' | translate}}" color="primary" (click)="verDetallesRT(producto.idCertificar)">
                              <mat-icon>playlist_add_check</mat-icon>
                            </button>
                            <button mat-fab class="mr-20 mb-20" matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaCertificar,producto.idCertificar,producto.idPlantilla,41,producto.idProducto);">
                              <mat-icon>arrow_downward</mat-icon>
                            </button>
                            <ng-container *ngIf="producto.tokenConfig">
                              <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONFING_RESUL.MAT_TOOL_BTN_CONFI_RESULT' | translate}}" color="primary" (click)="verConfigResult(producto.idProducto,producto.tokenConfig,producto);">
                                <mat-icon>view_quilt</mat-icon>
                              </button>
                            </ng-container>
                            <button mat-fab class="mr-20 mb-20"  matTooltip="{{'CONSULTATABLA.INF_BTN' | translate}}" color="primary" (click)="verInfoProduc(producto)" *ngIf="producto.idProducto == 41">
                              <mat-icon>info</mat-icon>
                            </button>
                            <button mat-fab class="mr-20 mb-20"  matTooltip="{{'CONSULTATABLA.DELE_PRODU' | translate}}" color="primary" (click)="eliminarProduct(producto.idCertificar,'v3')" *ngIf="producto.idProducto == 41 && btnDeletProduct">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </ng-container>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="center">
                          <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event,producto.secciones,producto.fechaCertificar,producto.idCertificar)">
                            <ng-container *ngIf="categoria.id != 16 && categoria.id != 11 && categoria.id != 41">
                              <!--Temporales -->
                              <ng-container *ngFor="let seccion of producto.secciones; let k = index">
                                <div class="example-box" *ngIf="seccion.visible == 1 && k!=0 && k!=2" cdkDrag>
                                  <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                                  <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                                    <mat-checkbox [(ngModel)]="seccion.estatus" (change)="updateStatus($event,seccion._id,producto.fechaCertificar,producto.idCertificar,producto.tokenConfig,seccion.nombre,producto.survey,producto.idProducto,indexProdGene,indexProducto,k)">
                                      {{'CONSULTATABLA.'+seccion.nombre | translate}}
                                    </mat-checkbox>
                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="categoria.id == 11">
                              <!--Temporales -->
                              <ng-container *ngFor="let seccion of producto.secciones; let k = index">
                                <div class="example-box" *ngIf="seccion.visible == 1  && k!=2" cdkDrag>
                                  <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                                  <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                                    <mat-checkbox [(ngModel)]="seccion.estatus" (change)="updateStatus($event,seccion._id,producto.fechaProducto,producto.idProducto,producto.tokenConfig,seccion.nombre,producto.survey,producto.idProducto,indexProdGene,indexProducto,k)">
                                      {{'CONSULTATABLA.'+seccion.nombre | translate}}
                                    </mat-checkbox>
                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="categoria.id == 16 || categoria.id == 41">
                              <!--Temporales -->
                              <ng-container *ngFor="let seccion of producto.secciones; let k = index">
                                <div class="example-box" *ngIf="seccion.visible == 1" cdkDrag>
                                  <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                                  <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                                    <mat-checkbox [(ngModel)]="seccion.estatus" (change)="updateStatus($event,seccion._id,producto.fechaCertificar,producto.idCertificar,producto.tokenConfig,seccion.nombre,producto.survey,producto.idProducto,indexProdGene,indexProducto,k)">
                                      {{'CONSULTATABLA.'+seccion.nombre | translate}}
                                    </mat-checkbox>
                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>

                          </div>
                        </div>

                      </mat-expansion-panel>
                    </ng-template>
                  </mat-expansion-panel>
                </ng-container>
              </mat-accordion>

            </mat-expansion-panel>

            <!-- <mat-expansion-panel *ngIf="productosContratadosInter.productosNorma35.length > 0" class="mb-20">
              <mat-expansion-panel-header class="accent-100">
                <mat-panel-title>
                  <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.3' | translate}}:</b> {{productosContratadosInter.productosNorma35.length}} {{'GESTORSTATUS.TITULO' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                  {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-list>
                <mat-list-item *ngFor="let producto of productosContratadosInter.productosNorma35; last as last">
                  <mat-icon matListIcon>arrow_right</mat-icon>
                  <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.3' | translate}} {{producto.fechaNorma35}}<br>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}: {{'CONSULTARENCUESTA.CATALOGOSPRODUCTOS.'+producto.idPlantilla+'.NOMBRE' | translate}}</mat-list-item>
                  <div fxLayout="column" fxLayoutAlign="space-between stretch">
                    <button mat-fab matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaNorma35,producto.idNorma35,producto.idPlantilla,5,producto.idProducto,producto.idSurveyMenos,producto.idSurveyMas);">
                      <mat-icon>arrow_downward</mat-icon>
                    </button>

                  <button *ngIf="validarNivelUser==3" mat-fab matTooltip="{{'CONSULTATABLA.LOG_SENDGRIND.TITULO' | translate}}" color="primary" (click)="logSendgrind(producto.idNorma35, producto.fechaNorma35, producto.idPlantilla, 'nom035')">
                    <mat-icon>build</mat-icon>
                  </button>
                  <ng-container *ngIf="producto.tokenConfig">
                    <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONFING_RESUL.MAT_TOOL_BTN_CONFI_RESULT' | translate}}" color="primary" (click)="verConfigResult(producto.idNorma35,producto.tokenConfig);">
                      <mat-icon>view_quilt</mat-icon>
                    </button>
                  </ng-container>
                </div>
                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
              </mat-list-item>
            </mat-list>

          </mat-expansion-panel> -->


          <mat-expansion-panel *ngIf="productosContratadosInter.productosNorma35.length > 0" class="mb-20">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.3' | translate}}:</b> {{productosContratadosInter.productosNorma35.length}} {{'GESTORSTATUS.TITULO' | translate}}
              </mat-panel-title>
              <mat-panel-description>
                {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-accordion>
              <ng-container *ngFor="let categoria of listaProdsNorma35;index as i; let indexProdGene=index ">

                <mat-expansion-panel *ngIf="categoria.lista.length > 0" class="m-20">
                  <mat-expansion-panel-header class="accent-100">
                    <mat-panel-title>
                      <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}}:</b> {{categoria.lista.length}} {{'GESTORSTATUS.TITULO' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <mat-expansion-panel *ngFor="let producto of categoria.lista; let indexProducto=index " class="m-20" >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="" fxLayout="column" fxLayoutAlign="center start">
                          <b class="mr-20 listCerTitulo">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}} {{producto.fechaNorma35}}</b>
                          <b class="mr-20 listCerTitulo" *ngIf="producto.tokenConfig" >| SurveyToken: {{producto.tokenConfig}}</b>
                        </div>
                      </mat-panel-title>
                      <mat-panel-description>
                        <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                        {{'CONSULTATABLA.INFOR' | translate}}
                        <div *ngIf="producto.correoPendiente" class="icoNuevoMail" matTooltip="{{'CONSULTATABLA.CORREOMODIF' | translate }}">
                          <mat-icon class="s-20">priority_high</mat-icon>
                        </div>
                        </div>
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <ng-container>
                      <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em> {{producto.idPlantilla}}</em> </p>
                    </ng-container>
                    <div fxLayout="row" fxLayoutAlign="start center">
                      <button  *ngIf="producto.idProducto==63" mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idNorma35,'Norma35',categoria.id,'')">
                        <mat-icon>settings</mat-icon>
                      </button>
                      <button mat-fab class="mr-20 mb-20" matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaNorma35,producto.idNorma35,producto.idPlantilla,5,producto.idProducto,producto.idSurveyMenos,producto.idSurveyMas);">
                        <mat-icon>arrow_downward</mat-icon>
                      </button>
                    <button *ngIf="validarNivelUser==3" mat-fab class="mr-20 mb-20"matTooltip="{{'CONSULTATABLA.LOG_SENDGRIND.TITULO' | translate}}" color="primary" (click)="logSendgrind(producto.idNorma35, producto.fechaNorma35, producto.idPlantilla, 'nom035')">
                      <mat-icon>build</mat-icon>
                    </button>
                    <ng-container *ngIf="producto.tokenConfig">
                      <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONFING_RESUL.MAT_TOOL_BTN_CONFI_RESULT' | translate}}" color="primary" (click)="verConfigResult(producto.idNorma35,producto.tokenConfig,producto);">
                        <mat-icon>view_quilt</mat-icon>
                      </button>
                    </ng-container>
                    </div>

                  </mat-expansion-panel>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="productosContratadosInter.productosPulseCheck.length > 0 || idsProductosCert3Falsos[1].activo" class="mb-20">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.4' | translate}}:</b>
              </mat-panel-title>
              <mat-panel-description>
                {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-accordion>
              <ng-container *ngFor="let categoria of listaProdsPulse; index as i; let indexProdGene =index">
                <mat-expansion-panel *ngIf="categoria.lista.length > 0" class="m-20">
                  <mat-expansion-panel-header class="accent-100">
                    <mat-panel-title>
                      <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}}:</b> {{categoria.lista.length}} {{'GESTORSTATUS.TITULO' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <mat-list *ngIf="categoria.id == 4; else nuevosPulse">
                    <mat-list-item *ngFor="let producto of categoria.lista; last as last">
                      <mat-icon matListIcon>arrow_right</mat-icon>
                      <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}} {{producto.fechaPulseCheck}}<br> {{'CONSULTARENCUESTA.PLANTILLA' | translate }}: {{'CONSULTARENCUESTA.CATALOGOSPRODUCTOS.'+producto.idPlantilla+'.NOMBRE' |
                        translate}}
                      </mat-list-item>
                      <!-- <p><button mat-raised-button color="primary" (click)="generatePDF(producto.fechaMedir,producto.idMedir)">{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate }}</button></p> -->
                      <div fxLayout="column" fxLayoutAlign="space-between stretch">

                        <!--(click)="generatePDF(producto.fechaMedir,producto.idMedir)"-->
                        <button mat-fab matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaPulseCheck,producto.idPulseCheck,producto.idPlantilla,categoria.id,producto.idProducto);" class="m-5">
                          <!---->
                          <mat-icon>arrow_downward</mat-icon>
                        </button>
                        <!-- <button mat-fab matTooltip="{{'CONSULTATABLA.FILEMANODS' | translate }}" color="primary" (click)="verCloud(producto.idMedir)" class="m-5">
                        <mat-icon>insert_drive_file</mat-icon>
                      </button> -->
                      <button mat-fab matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idPulseCheck,'Pulse',categoria.id)" class="m-5">
                        <mat-icon>settings</mat-icon>
                      </button>
                      <!-- <button *ngIf="validarNivelUser==3" mat-fab matTooltip="{{'CONSULTATABLA.LOG_SENDGRIND.TITULO' | translate}}" color="primary" (click)="logSendgrind(producto.fechaPulseCheck, producto.idPulseCheck, producto.idPlantilla, 'pulse')">
                      <mat-icon>build</mat-icon>
                    </button> -->
                    <ng-container *ngIf="producto.tokenConfig">
                      <button mat-fab class="mr-20 mb-20" matTooltip="Configuracion de resultados" color="primary" (click)="verConfigResult(producto.idPulseCheck,producto.tokenConfig,producto);">
                        <mat-icon>view_quilt</mat-icon>
                      </button>
                    </ng-container>
                  </div>
                  <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                </mat-list-item>
              </mat-list>

              <ng-template #nuevosPulse>
                <mat-expansion-panel *ngFor="let producto of categoria.lista;let indexProducto =index" class="m-20">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}} {{producto.fechaCertificar}}</b>
                    </mat-panel-title>
                    <mat-panel-description>
                      {{'CONSULTATABLA.CONFIGURE' | translate}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <ng-container *ngIf="producto.idProducto != 42">
                    <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}: </b> <em>{{'CONSULTARENCUESTA.CATALOGOSPRODUCTOS.'+producto.idPlantilla+'.NOMBRE' | translate}}</em> </p>
                  </ng-container>
                  <ng-container *ngIf="producto.idProducto == 42">
                    <p><b >{{'CONSULTARENCUESTA.PLANTILLA' | translate }}: </b> <em> {{producto.surveyProductId.name}}</em> </p>
                  </ng-container>

                  <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idCertificar,'Pulse3',categoria.id)">
                      <mat-icon>settings</mat-icon>
                    </button>
                    <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.RTINFO' | translate}}" color="primary" (click)="verDetallesRT(producto.idCertificar)">
                      <mat-icon>playlist_add_check</mat-icon>
                    </button>
                    <button mat-fab class="mr-20 mb-20" matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaCertificar,producto.idCertificar,producto.idPlantilla,4,producto.idProducto);">
                      <mat-icon>arrow_downward</mat-icon>
                    </button>
                    <ng-container *ngIf="producto.tokenConfig">
                      <button mat-fab class="mr-20 mb-20" matTooltip="Configuracion de resultados" color="primary" (click)="verConfigResult(producto.idCertificar,producto.tokenConfig,producto);">
                        <mat-icon>view_quilt</mat-icon>
                      </button>
                    </ng-container>
                    <button mat-fab class="mr-20 mb-20"  matTooltip="{{'CONSULTATABLA.DELE_PRODU' | translate}}" color="primary" (click)="eliminarProduct(producto.idCertificar,'v3')" *ngIf="producto.idProducto == 42 && btnDeletProduct">
                      <mat-icon>delete</mat-icon>
                    </button>

                  </div>

                  <div fxLayout="row" fxLayoutAlign="center">
                    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event,producto.secciones,producto.fechaProducto,producto.idCertificar)">
                      <ng-container>
                        <!--Temporales -->
                        <ng-container *ngFor="let seccion of producto.secciones; let k = index">
                          <div class="example-box" *ngIf="seccion.visible == 1" cdkDrag>
                            <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                            <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                              <mat-checkbox [(ngModel)]="seccion.estatus" (change)="updateStatus($event,seccion._id,producto.fechaProducto,producto.idCertificar,producto.tokenConfig,seccion.nombre,producto.survey,producto.idProducto,indexProdGene,indexProducto,k)">
                                {{'CONSULTATABLA.'+seccion.nombre | translate}}
                              </mat-checkbox>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>

                    </div>
                  </div>

                </mat-expansion-panel>
              </ng-template>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="productosContratadosInter.productosDocumentador.length > 0" class="mb-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.5' | translate}}:</b> {{productosContratadosInter.productosDocumentador.length}} {{'GESTORSTATUS.TITULO' | translate}}
          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-expansion-panel *ngIf="productosDocumentadorNormaV1.length > 0" class="m-20">
          <mat-expansion-panel-header class="accent-100">
            <mat-panel-title>
              <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.5' | translate}}:</b> {{productosDocumentadorNormaV1.length}} {{'GESTORSTATUS.TITULO' | translate}}
            </mat-panel-title>
            <mat-panel-description>
              {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-list>
            <mat-list-item *ngFor="let producto of productosDocumentadorNormaV1; last as last">
              <mat-icon matListIcon>arrow_right</mat-icon>
              <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.5' | translate}} {{producto.fechaDocumentador}}</mat-list-item>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <!-- <button mat-raised-button color="primary" (click)="verCloud(producto.idProducto)" class="ml-20">
                {{'CONSULTATABLA.FILEMANODS' | translate }}
                <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
                <!-- </button> -->
              </div>
              <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
            </mat-list-item>
          </mat-list>

        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="productosDocumentadorNormaV3.length > 0" class="m-20">
          <mat-expansion-panel-header class="accent-100">
            <mat-panel-title>
              <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.5' | translate}} v3.0:</b> {{productosDocumentadorNormaV3.length}} {{'GESTORSTATUS.TITULO' | translate}}
            </mat-panel-title>
            <mat-panel-description>
              {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-list>
            <mat-list-item *ngFor="let producto of productosDocumentadorNormaV3; last as last">
              <mat-icon matListIcon>arrow_right</mat-icon>
              <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.5' | translate}} v3.0 {{producto.fechaDocumentador}}</mat-list-item>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <!-- <button mat-raised-button color="primary" (click)="verCloud(producto.idProducto)" class="ml-20">
                {{'CONSULTATABLA.FILEMANODS' | translate }}
                <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
                <!-- </button> -->
              </div>
              <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
            </mat-list-item>
          </mat-list>

        </mat-expansion-panel>



      </mat-expansion-panel>

      <!-- Focus Area version renovada -->
      <mat-expansion-panel *ngIf="productosContratadosInter.productosFocusArea.length > 0 || idsProductosCert3Falsos[2].activo" class="mb-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.43' | translate}}:</b>
          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-accordion>
          <ng-container *ngFor="let categoria of aniosFocusAgregados; index as i; let indexFocusPrin =index">
            <mat-expansion-panel  class="m-20">
              <mat-expansion-panel-header class="accent-100">
                <mat-panel-title>
                  <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.43' | translate}}: {{categoria.fecha}}</b> {{categoria.datos.length}} {{'GESTORSTATUS.TITULO' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                  {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                </mat-panel-description>
              </mat-expansion-panel-header>
              <button mat-fab class="m-5" matTooltip="{{'CONSULTARENCUESTA.VIZUENCU' | translate }}" color="warn" (click)="navigateToFocus('companies/detail/:id/control-encuesta',idEmpresa,'',categoria.fecha,'version3')">
                <mat-icon>search</mat-icon>
              </button>
              <mat-expansion-panel *ngFor="let producto of categoria.datos; let indexFocus=index" class="m-20">
                <!-- <ng-container *ngIf="producto.fechaCertificar==categoria.fecha"> -->
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.43' | translate}} {{producto.fechaCertificar}}</b>
                  </mat-panel-title>
                  <mat-panel-description>
                    {{'CONSULTATABLA.CONFIGURE' | translate}}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <ng-container *ngIf="producto.idProducto != 43">
                  <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}: </b> <em>{{'CONSULTARENCUESTA.CATALOGOSPRODUCTOS.'+producto.idPlantilla+'.NOMBRE' | translate}}</em> </p>
                </ng-container>
                <ng-container *ngIf="producto.idProducto == 43">
                  <p><b >{{'CONSULTARENCUESTA.PLANTILLA' | translate }}: </b> <em> {{producto.surveyProductId.name}}</em> </p>
                  <p><b >{{'CONSULTATABLA.NAME_SURVEY' | translate }} </b> <em> {{producto.nameSurvey}}</em> </p>
                </ng-container>

                <div fxLayout="row" fxLayoutAlign="start center">
                  <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idCertificar,'Focus 1',producto.idProducto)">
                    <mat-icon>settings</mat-icon>
                  </button>
                  <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.RTINFO' | translate}}" color="primary" (click)="verDetallesRT(producto.idCertificar)">
                    <mat-icon>playlist_add_check</mat-icon>
                  </button>
                  <button mat-fab class="mr-20 mb-20" matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaCertificar,producto.idCertificar,producto.idPlantilla,4,producto.idProducto);">
                    <mat-icon>arrow_downward</mat-icon>
                  </button>
                  <ng-container *ngIf="producto.tokenConfig">
                    <button mat-fab class="mr-20 mb-20" matTooltip="Configuracion de resultados" color="primary" (click)="verConfigResult(producto.idPulseCheck,producto.tokenConfig,producto);">
                      <mat-icon>view_quilt</mat-icon>
                    </button>
                  </ng-container>
                  <button mat-fab class="mr-20 mb-20"  matTooltip="{{'CONSULTATABLA.DELE_PRODU' | translate}}" color="primary" (click)="eliminarProduct(producto.idCertificar,'v3')" *ngIf="producto.idProducto == 43 && btnDeletProduct">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>

                <div fxLayout="row" fxLayoutAlign="center">
                  <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event,producto.secciones,producto.fechaProducto,producto.idCertificar)">
                    <ng-container>
                      <ng-container *ngFor="let seccion of producto.secciones; let k = index">
                        <div class="example-box" *ngIf="seccion.visible == 1" cdkDrag>
                          <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                          <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                            <mat-checkbox [(ngModel)]="seccion.estatus" (change)="updateStatus($event,seccion._id,producto.fechaProducto,producto.idCertificar,producto.tokenConfig,seccion.nombre,producto.survey,producto.idProducto,indexFocusPrin,indexFocus,k)">
                              {{'CONSULTATABLA.'+seccion.nombre | translate}}
                            </mat-checkbox>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>

                  </div>
                </div>
                <!-- </ng-container> -->

              </mat-expansion-panel>




            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="productosContratadosInter.productosCultureAudit.length > 0 || listaProductosCultureAuditV2.length > 0 || productosContratadosInter.productosCultureAuditTR.length > 0 || listaProductosCultureBrief.length > 0" class="mb-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <span *ngIf="instituto != 18">
              <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.8' | translate}}:</b>
            </span>
            <span *ngIf="instituto == 18">
              <b class="mr-20">ICCA:</b>
            </span>
          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-accordion>
          <mat-expansion-panel *ngIf="productosContratadosInter.productosCultureAudit.length > 0" class="m-20">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.8' | translate}}:</b> {{productosContratadosInter.productosCultureAudit.length}} {{'GESTORSTATUS.TITULO' | translate}}
              </mat-panel-title>
              <mat-panel-description>
                {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-list>
              <mat-list-item *ngFor="let producto of productosContratadosInter.productosCultureAudit; last as last">
                <mat-icon matListIcon>arrow_right</mat-icon>
                <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.8' | translate}} {{producto.fechaCulture}}</mat-list-item>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <!-- <button mat-raised-button color="primary" (click)="verCloud(producto.idCulture)" class="ml-20">
                  {{'CONSULTATABLA.FILEMANODS' | translate }}
                  <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
                  <!-- </button> -->
                </div>
                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
              </mat-list-item>
            </mat-list>

          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="verListCultureAuditV2" class="m-20">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                <ng-container *ngIf="instituto != 5">
                  <span *ngIf="instituto != 18">
                    <b class="mr-20">{{'CONSULTATABLA.CATEGORIAS.Culture Audit' | translate}}:</b> {{listaProductosCultureAuditV2.length}} {{'GESTORSTATUS.TITULO' | translate}}
                  </span>
                  <span *ngIf="instituto == 18">
                    <b class="mr-20">ICCA:</b> {{listaProductosCultureAuditV2.length}} {{'GESTORSTATUS.TITULO' | translate}}
                  </span>
                </ng-container>
                <ng-container *ngIf="instituto == 5">
                  <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.8' | translate}}:</b> {{listaProductosCultureAuditV2.length}} {{'GESTORSTATUS.TITULO' | translate}}
                </ng-container>

              </mat-panel-title>
              <mat-panel-description>
                {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                <!-- Clic aquí para ver la lista de productos -->
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-list >
              <mat-list-item *ngFor="let producto of listaProductosCultureAuditV2; last as last">
                  <mat-icon matListIcon>arrow_right</mat-icon>
                  <ng-container [ngSwitch]="instituto">
                    <ng-container *ngSwitchCase="1">
                      <ng-container [ngSwitch]="producto.tipo">
                        <mat-list-item *ngSwitchCase="4">{{'CONSULTATABLA.PRODUCTOS.30' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="5">{{'CONSULTATABLA.PRODUCTOS.31' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="6">{{'CONSULTATABLA.PRODUCTOS.32' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="7">{{'CONSULTATABLA.PRODUCTOS.33' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="10">{{'CONSULTATABLA.PRODUCTOS.44' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="11">{{'CONSULTATABLA.PRODUCTOS.45' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="12">{{'CONSULTATABLA.PRODUCTOS.46' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="14">{{'CONSULTATABLA.PRODUCTOS.48' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="15">{{'CONSULTATABLA.PRODUCTOS.49' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="22">{{'CONSULTATABLA.PRODUCTOS.64' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="23">{{'CONSULTATABLA.PRODUCTOS.65' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="24">{{'CONSULTATABLA.PRODUCTOS.66' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="25">{{'CONSULTATABLA.PRODUCTOS.67' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="26">{{'CONSULTATABLA.PRODUCTOS.71' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="27">{{'CONSULTATABLA.PRODUCTOS.72' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="28">{{'CONSULTATABLA.PRODUCTOS.73' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="29">{{'CONSULTATABLA.PRODUCTOS.74' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="30">{{'CONSULTATABLA.PRODUCTOS.76' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="31">{{'CONSULTATABLA.PRODUCTOS.77' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="32">{{'CONSULTATABLA.PRODUCTOS.78' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchDefault>{{'CONSULTATABLA.PRODUCTOS.9' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="3">
                      <ng-container [ngSwitch]="producto.tipo">
                        <mat-list-item *ngSwitchCase="8">{{'CONSULTATABLA.PRODUCTOS.37' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="16">{{'CONSULTATABLA.PRODUCTOS.50' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="17">{{'CONSULTATABLA.PRODUCTOS.51' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="70">{{'CONSULTATABLA.PRODUCTOS.70' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchDefault>{{'CONSULTATABLA.PRODUCTOS.9' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="5">
                      <ng-container [ngSwitch]="producto.tipo">
                        <mat-list-item *ngSwitchCase="2">{{'CONSULTATABLA.PRODUCTOSTURQUIA.28' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="3">{{'CONSULTATABLA.PRODUCTOSTURQUIA.29' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="29">{{'CONSULTATABLA.PRODUCTOSTURQUIA.74' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchDefault>{{'CONSULTATABLA.PRODUCTOSTURQUIA.9' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="18">
                      <mat-list-item *ngIf="producto.tipo == 18">{{'CONSULTATABLA.PRODUCTOS.55' | translate}} {{producto.fechaCulture}}</mat-list-item>
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                      <ng-container [ngSwitch]="producto.tipo">
                        <mat-list-item *ngSwitchCase="61">{{'CONSULTATABLA.PRODUCTOS.61' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="62">{{'CONSULTATABLA.PRODUCTOS.62' | translate}} {{producto.fechaCulture}}</mat-list-item>
                        <mat-list-item *ngSwitchCase="34">{{'CONSULTATABLA.PRODUCTOS.80' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.9' | translate}} {{producto.fechaCulture}}</mat-list-item>
                    </ng-container>
                  </ng-container>
                  <!-- <mat-list-item *ngIf="instituto != 5 && instituto != 1 && producto.tipo != 8">{{'CONSULTATABLA.PRODUCTOS.9' | translate}} {{producto.fechaCulture}}</mat-list-item> -->
                  <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
                    <button mat-raised-button color="primary" (click)="actualizarCA(producto.idCulture)" class="m-5">
                      <ng-container *ngIf="instituto != 18">
                        {{'PERFILES.EMPRESA.ACTUALIZARCA.ACTUALIZARCA' | translate }}
                      </ng-container>
                      <ng-container *ngIf="instituto == 18">
                        {{'PERFILES.EMPRESA.ACTUALIZARCA.ACTUALIZAR_ICCA' | translate }}
                      </ng-container>
                      <mat-icon class="ml-20">update</mat-icon>
                    </button>
                    <button mat-raised-button class="m-5" color="primary" (click)="eliminarProduct(producto.idCulture,'culture')" *ngIf="btnDeletProduct">
                      {{'CONSULTATABLA.DELE_PRODU' | translate}}
                      <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="enterpriseData.idCgoExprs" mat-raised-button color="primary" (click)="irCACGOX(producto.fechaCulture)" class="m-5">
                      {{'PERFILES.EMPRESA.ACTUALIZARCA.IRACA_CGOX' | translate }}
                      <mat-icon class="ml-20">send</mat-icon>
                    </button>
                    <!-- <button mat-raised-button color="primary" (click)="verCloud(producto.idCulture)" class="m-5">
                      {{'CONSULTATABLA.FILEMANODS' | translate }}
                      <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
                      <!-- </button> -->
                    </div>
                    <mat-divider [inset]="true" *ngIf="!last"></mat-divider>

              </mat-list-item>
            </mat-list>

          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="verListCultureBrief" class="m-20">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                <b class="mr-20">{{'CONSULTATABLA.CATEGORIAS.Culture Audit' | translate}}:</b> {{listaProductosCultureBrief.length}} {{'GESTORSTATUS.TITULO' | translate}}
              </mat-panel-title>
              <mat-panel-description>
                {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-list>
              <mat-list-item *ngFor="let producto of listaProductosCultureBrief; last as last">
                <mat-icon matListIcon>arrow_right</mat-icon>
                <ng-container [ngSwitch]="producto.tipo">
                  <mat-list-item *ngSwitchCase="20">{{'CONSULTATABLA.PRODUCTOS.61' | translate}} {{producto.fechaCulture}}</mat-list-item>
                  <mat-list-item *ngSwitchCase="21">{{'CONSULTATABLA.PRODUCTOS.62' | translate}} {{producto.fechaCulture}}</mat-list-item>
                </ng-container>
                <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
                  <button mat-raised-button color="primary" (click)="actualizarCA(producto.idCulture)" class="m-5">
                    <ng-container [ngSwitch]="producto.tipo">
                      <b *ngSwitchCase="20">{{'PERFILES.EMPRESA.ACTUALIZARCA.ACTUALIZARCA_BRI' | translate }}</b>
                      <b *ngSwitchCase="21">{{'PERFILES.EMPRESA.ACTUALIZARCA.ACTUALIZARCA' | translate }}</b>
                    </ng-container>
                    <mat-icon class="ml-20">update</mat-icon>
                  </button>
                  <button mat-raised-button class="m-5" color="primary" (click)="eliminarProduct(producto.idCulture,'culture')" *ngIf="btnDeletProduct">
                    {{'CONSULTATABLA.DELE_PRODU' | translate}}
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
              </mat-list-item>
            </mat-list>

          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="productosContratadosInter.productosCultureAuditTR.length > 0" class="m-20">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.10' | translate}}:</b> {{productosContratadosInter.productosCultureAuditTR.length}} {{'GESTORSTATUS.TITULO' | translate}}
              </mat-panel-title>
              <mat-panel-description>
                {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-list>
              <mat-list-item *ngFor="let producto of productosContratadosInter.productosCultureAuditTR; last as last">
                <mat-icon matListIcon>arrow_right</mat-icon>
                <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.10' | translate}} {{producto.fechaCulture}}</mat-list-item>
                <div fxLayout="row" fxLayoutAlign="space-between center">
            </div>
                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
              </mat-list-item>
            </mat-list>

          </mat-expansion-panel>
        </mat-accordion>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="listaProductosCultureAuditICCA.length > 0 && instituto==1 " class="mb-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>

            <span>
              <b class="mr-20">ICCA:</b>
            </span>
          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-accordion>

          <mat-expansion-panel *ngIf="listaProductosCultureAuditICCA.length > 0" class="m-20">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                <ng-container *ngIf="instituto ==1">
                  <span>
                    <b class="mr-20">ICCA:</b> {{listaProductosCultureAuditICCA.length}} {{'GESTORSTATUS.TITULO' | translate}}
                  </span>
                </ng-container>
              </mat-panel-title>
              <mat-panel-description>
                {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-list>
              <mat-list-item *ngFor="let producto of listaProductosCultureAuditICCA; last as last">
                <mat-icon matListIcon>arrow_right</mat-icon>
                <ng-container [ngSwitch]="instituto">
                  <ng-container *ngSwitchCase="1">
                    <ng-container [ngSwitch]="producto.tipo">
                      <mat-list-item *ngSwitchCase="4">{{'CONSULTATABLA.PRODUCTOS.30' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="5">{{'CONSULTATABLA.PRODUCTOS.31' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="6">{{'CONSULTATABLA.PRODUCTOS.32' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="7">{{'CONSULTATABLA.PRODUCTOS.33' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="10">{{'CONSULTATABLA.PRODUCTOS.44' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="11">{{'CONSULTATABLA.PRODUCTOS.45' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="12">{{'CONSULTATABLA.PRODUCTOS.46' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="14">{{'CONSULTATABLA.PRODUCTOS.48' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="15">{{'CONSULTATABLA.PRODUCTOS.49' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="19">{{'CONSULTATABLA.PRODUCTOS.55' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="61">{{'CONSULTATABLA.PRODUCTOS.61' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="62">{{'CONSULTATABLA.PRODUCTOS.62' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="22">{{'CONSULTATABLA.PRODUCTOS.64' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="23">{{'CONSULTATABLA.PRODUCTOS.65' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="24">{{'CONSULTATABLA.PRODUCTOS.66' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="25">{{'CONSULTATABLA.PRODUCTOS.67' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="26">{{'CONSULTATABLA.PRODUCTOS.71' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="27">{{'CONSULTATABLA.PRODUCTOS.72' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="28">{{'CONSULTATABLA.PRODUCTOS.73' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="29">{{'CONSULTATABLA.PRODUCTOS.74' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="30">{{'CONSULTATABLA.PRODUCTOS.76' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="31">{{'CONSULTATABLA.PRODUCTOS.77' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="32">{{'CONSULTATABLA.PRODUCTOS.78' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchCase="80">{{'CONSULTATABLA.PRODUCTOS.80' | translate}} {{producto.fechaCulture}}</mat-list-item>
                      <mat-list-item *ngSwitchDefault>{{'CONSULTATABLA.PRODUCTOS.9' | translate}} {{producto.fechaCulture}}</mat-list-item>
                    </ng-container>
                  </ng-container>

                </ng-container>
                <!-- <mat-list-item *ngIf="instituto != 5 && instituto != 1 && producto.tipo != 8">{{'CONSULTATABLA.PRODUCTOS.9' | translate}} {{producto.fechaCulture}}</mat-list-item> -->
                <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
                  <button mat-raised-button color="primary" (click)="actualizarCA(producto.idCulture)" class="m-5">
                    <ng-container >
                      {{'PERFILES.EMPRESA.ACTUALIZARCA.ACTUALIZAR_ICCA' | translate }}
                    </ng-container>
                    <mat-icon class="ml-20">update</mat-icon>
                  </button>
                  <button *ngIf="enterpriseData.idCgoExprs" mat-raised-button color="primary" (click)="irCACGOX(producto.fechaCulture)" class="m-5">
                    {{'PERFILES.EMPRESA.ACTUALIZARCA.IRACA_CGOX' | translate }}
                    <mat-icon class="ml-20">send</mat-icon>
                  </button>
                  <button mat-raised-button class="m-5" color="primary" (click)="eliminarProduct(producto.idCulture,'culture')" *ngIf="btnDeletProduct">
                    {{'CONSULTATABLA.DELE_PRODU' | translate}}
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
              </mat-list-item>
            </mat-list>

          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="productosContratadosInter.productosCultureAuditTR.length > 0" class="m-20">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.10' | translate}}:</b> {{productosContratadosInter.productosCultureAuditTR.length}} {{'GESTORSTATUS.TITULO' | translate}}
              </mat-panel-title>
              <mat-panel-description>
                {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                <!-- Clic aquí para ver la lista de productos -->
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-list>
              <mat-list-item *ngFor="let producto of productosContratadosInter.productosCultureAuditTR; last as last">
                <mat-icon matListIcon>arrow_right</mat-icon>
                <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.10' | translate}} {{producto.fechaCulture}}</mat-list-item>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <!-- <button mat-raised-button color="primary" (click)="verCloud(producto.idCulture)" class="ml-20">
                  {{'CONSULTATABLA.FILEMANODS' | translate }}
                  <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
                  <!-- </button> -->
                </div>
                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
              </mat-list-item>
            </mat-list>

          </mat-expansion-panel>
        </mat-accordion>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="productosContratadosInter.productosResultados.length > 0 || productosContratadosInter.productosResultados5cero.length > 0" class="mb-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.17' | translate}}:</b> {{productosContratadosInter.productosResultados.length + productosContratadosInter.productosResultados5cero.length}} {{'GESTORSTATUS.TITULO'
            | translate}}
          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
            <!-- Clic aquí para ver la lista de productos -->
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let producto of productosContratadosInter.productosResultados; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>
            <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.17' | translate}} {{producto.fecha}}</mat-list-item>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <!-- <button mat-raised-button color="primary" (click)="verCloud(producto._id)" class="ml-20">
              {{'CONSULTATABLA.FILEMANODS' | translate }}
              <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
              <!-- </button> -->
            </div>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>
        <mat-list>
          <mat-list-item *ngFor="let producto of productosContratadosInter.productosResultados5cero; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>
            <mat-list-item>{{producto.nombreProducto}} {{producto.fecha}}</mat-list-item>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <!-- <button mat-raised-button color="primary" (click)="verCloud(producto._id)" class="ml-20">
              {{'CONSULTATABLA.FILEMANODS' | translate }}
              <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
              <!-- </button> -->
            </div>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>


      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="listaProdsGoflow[0].lista.length > 0" class="m-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <ng-container>
              <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.70' | translate}}</b> {{listaProdsGoflow[0].lista.length}}
            </ng-container>

          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let producto of listaProdsGoflow[0].lista; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>
            <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.70' | translate}} {{producto.fechaCertificar}}</mat-list-item>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONFING_RESUL.MAT_TOOL_BTN_CONFI_RESULT' | translate}}" color="primary" (click)="verInfoProducGoFlow(producto)">
                <mat-icon>view_quilt</mat-icon>
              </button>
            </div>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>

      </mat-expansion-panel>

      <!--OTRA NUEVA -->
      <mat-expansion-panel *ngIf="productosContratadosInter.productosResultados4all.length > 0" class="mb-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.18' | translate}}:</b> {{productosContratadosInter.productosResultados4all.length}} {{'GESTORSTATUS.TITULO' | translate}}
          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
            <!-- Clic aquí para ver la lista de productos -->
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let producto of productosContratadosInter.productosResultados4all; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>
            <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.18' | translate}} {{producto.fecha}}</mat-list-item>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <!-- <button mat-raised-button color="primary" (click)="verCloud(producto._id)" class="ml-20">
              {{'CONSULTATABLA.FILEMANODS' | translate }}
              <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
              <!-- </button> -->
            </div>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>

      </mat-expansion-panel>
      <!--Action plan-->
      <mat-expansion-panel *ngIf="listaAction.length > 0" class="m-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <ng-container>
              <b class="mr-20">{{'CONSULTATABLA.CATEGORIAS.Culture Audit Action Plan' | translate}}:</b> {{listaAction.length}} {{'GESTORSTATUS.TITULO' | translate}}
            </ng-container>

          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
            <!-- Clic aquí para ver la lista de productos -->
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let producto of listaAction; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>

            <mat-list-item *ngIf="producto.tipo == 9">{{'CONSULTATABLA.PRODUCTOS.38' | translate}} {{producto.fechaCulture}}</mat-list-item>
            <div fxLayout="column" fxLayoutAlign="space-between stretch">
              <button mat-raised-button color="primary" (click)="actualizarCA(producto.idCulture,1)" class="m-5">
                {{'PERFILES.EMPRESA.ACTUALIZARCA.ACTUALIZARCA_ACTIAN' | translate }}
                <mat-icon class="ml-20">update</mat-icon>
              </button>
              <!-- <button mat-raised-button color="primary" (click)="verCloud(producto.idCulture)" class="m-5">
              {{'CONSULTATABLA.FILEMANODS' | translate }}
              <mat-icon class="ml-20">insert_drive_file</mat-icon> -->
              <!-- </button> -->
            </div>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>

      </mat-expansion-panel>
      <!--Culral go express-->
      <mat-expansion-panel *ngIf="listaProdsExpress.length > 0" class="m-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <ng-container>
              <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.CULTUREGOEXPRESS' | translate}}</b> {{listaProdsExpress.length}}
            </ng-container>

          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
            <!-- Clic aquí para ver la lista de productos -->
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let producto of listaProdsExpress; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>

            <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.CULTUREGOEXPRESS' | translate}} {{producto.date}}</mat-list-item>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>

      </mat-expansion-panel>
      <!--Leader GO-->
      <mat-expansion-panel *ngIf="listaProdsLeaderGo[0].lista.length > 0" class="m-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <ng-container>
              <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.53' | translate}}</b> {{listaProdsLeaderGo[0].lista.length}}
            </ng-container>

          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
            <!-- Clic aquí para ver la lista de productos -->
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let producto of listaProdsLeaderGo[0].lista; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>

            <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.53' | translate}} {{producto.fechaCertificar}}</mat-list-item>
            <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idCertificar,producto.nombreProducto,'')">
              <mat-icon>settings</mat-icon>
            </button>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>

      </mat-expansion-panel>
      <!--Action GO-->
      <mat-expansion-panel *ngIf="listaProdsActionGo[0].lista.length > 0" class="m-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <ng-container>
              <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.54' | translate}}</b> {{listaProdsActionGo[0].lista.length}}
            </ng-container>

          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let producto of listaProdsActionGo[0].lista; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>
            <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.54' | translate}} {{producto.fechaCertificar}}</mat-list-item>
            <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idCertificar,producto.nombreProducto,'')">
              <mat-icon>settings</mat-icon>
            </button>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="mostrarProdsCerAmco" class="mb-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.ENCUESTA' | translate}}</b>
          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-accordion>
          <ng-container *ngFor="let categoria of listaProdsCerAmco;index as i; let indexProdGene=index ">
            <mat-expansion-panel *ngIf="categoria.lista.length > 0" class="m-20">
              <mat-expansion-panel-header class="accent-100">
                <mat-panel-title>
                  <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}}:</b> {{categoria.lista.length}} {{'GESTORSTATUS.TITULO' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                  {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-expansion-panel *ngFor="let producto of categoria.lista; let indexProducto=index " class="m-20">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="" fxLayout="column" fxLayoutAlign="start start">
                      <b class="mr-20 listCerTitulo">{{'CONSULTATABLA.PRODUCTOS.'+categoria.id | translate}} {{producto.fechaCertificar}}</b>
                      <b class="mr-20 listCerTitulo" *ngIf="producto.tokenConfig" >| SurveyToken: {{producto.tokenConfig}}</b>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description>
                    {{'CONSULTATABLA.CONFIGURE' | translate}}
                    <div *ngIf="producto.correoPendiente" class="icoNuevoMail" matTooltip="{{'CONSULTATABLA.CORREOMODIF' | translate }}">
                      <mat-icon class="s-20">priority_high</mat-icon>
                    </div>
                  </mat-panel-description>
                </mat-expansion-panel-header>


                <p><b>{{'CONSULTARENCUESTA.PLANTILLA' | translate }}:</b> <em> {{producto.surveyProductId.name}}</em> </p>

                <div fxLayout="row" fxLayoutAlign="start center">
                  <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.MODIFBTN' | translate}}" color="primary" (click)="verCorreosPendientes(producto.idCertificar,producto.nombreProducto,categoria.id,producto.tokenConfig,producto.createdAt)">
                    <mat-icon>settings</mat-icon>
                  </button>
                  <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.RTINFO' | translate}}" color="primary" (click)="verDetallesRT(producto.idCertificar)">
                    <mat-icon>playlist_add_check</mat-icon>
                  </button>
                  <button mat-fab class="mr-20 mb-20" matTooltip="{{'DESCARGAR_ENCUESTA.DESCARGARENCUESTA' | translate}}" color="primary" (click)="openDialog(producto.fechaCertificar,producto.idCertificar,producto.idPlantilla,1,producto.idProducto);">
                    <mat-icon>arrow_downward</mat-icon>
                  </button>
                  <ng-container *ngIf="producto.tokenConfig">
                    <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONFING_RESUL.MAT_TOOL_BTN_CONFI_RESULT' | translate}}" color="primary" (click)="verConfigResult(producto.idCertificar,producto.tokenConfig,producto);">
                      <mat-icon>view_quilt</mat-icon>
                    </button>
                  </ng-container>
                </div>

                <div fxLayout="row" fxLayoutAlign="center" >

                  <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event,producto.secciones,producto.fechaCertificar,producto.idCertificar)" >
                    <ng-container *ngFor="let seccion of producto.secciones;let indexSecc =index ">
                      <div class="example-box" *ngIf="seccion.visible == 1" cdkDrag style="padding-top: 5px;">
                        <mat-icon aria-hidden="false" class="mr-20" matTooltip="" cdkDragHandle>menu</mat-icon>
                        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                        <div appearance="outline" fxFlex="50" class="pr-4" fxLayoutAlign="start center">
                          <mat-checkbox [(ngModel)]="seccion.estatus" (change)="updateStatus($event,seccion._id,producto.fechaCertificar,producto.idCertificar,producto.tokenConfig,seccion.nombre,producto.survey,producto.idProducto,indexProdGene,indexProducto,indexSecc)">
                            {{'CONSULTATABLA.'+seccion.nombre | translate}}
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>

              </mat-expansion-panel>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="listaProdsCerEmprising[0].lista.length > 0" class="m-20">
        <mat-expansion-panel-header class="accent-100">
          <mat-panel-title>
            <ng-container>
              <b class="mr-20">{{'CONSULTATABLA.PRODUCTOS.60' | translate}}</b> {{listaProdsCerEmprising[0].lista.length}}
            </ng-container>

          </mat-panel-title>
          <mat-panel-description>
            {{'GESTORSTATUS.PRODUCTOS.BOTACCESO' | translate}}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let producto of listaProdsCerEmprising[0].lista; last as last">
            <mat-icon matListIcon>arrow_right</mat-icon>
            <mat-list-item>{{'CONSULTATABLA.PRODUCTOS.60' | translate}} {{producto.fechaCertificar}}</mat-list-item>
            <button mat-fab class="mr-20 mb-20" matTooltip="{{'CONSULTATABLA.TOOTI_RES_EMPR' | translate}}" color="primary" (click)="ResultEmprising(producto.idCertificar,producto.tokenConfig,producto.fileFlags);">
              <span class="material-icons-outlined">
                fact_check
              </span>
            </button>
            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>

      </mat-expansion-panel>



    </ng-container>

  </mat-accordion>
</div>

</div>


</div>
<!-- / CONTENT -->

</div>
